import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
import { authSettingsApiRelativePath, createAuthSettingsApi } from './index';
export var createAuthSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAuthSettingsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetSettings: function (brandId) {
            return createFakeGetResponder(fakeHttp, "" + authSettingsApiRelativePath + (brandId ? "?brandId=" + brandId : ''));
        },
        whenUpdateSettings: function (dto) {
            return createFakePutResponder(fakeHttp, "" + authSettingsApiRelativePath)(dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map